import type { ZudokuConfig } from "zudoku"
import { NotFound } from "./src/NotFound"

const config: ZudokuConfig = {
  metadata: {
    title: "Radarbov API Docs",
    favicon: "/favicon.svg",
  },
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      width: 130,
      alt: "RadarBov",
    },
    notFoundPage: <NotFound />,
  },
  defaults: {
    apis: {
      // @ts-ignore
      disableSecurity: false,
      expandAllTags: false,
      schemaDownload: {
        enabled: true,
      },
    },
  },
  search: {
    type: "pagefind",
  },
  aiAssistants: ["claude"],
  catalogs: {
    path: "catalog",
    label: "APIs",
  },
  apis: [
    {
      type: "file",
      input: "schema/dev-public.json",
      path: "dev/public",
      categories: [{ label: "Dev — Public", tags: ["REST", "JSON"] }],
    },
    {
      type: "file",
      input: "schema/dev-private.json",
      path: "dev/private",
      categories: [{ label: "Dev — Private", tags: ["REST", "JSON"] }],
    },
    {
      type: "file",
      input: "schema/staging-public.json",
      path: "staging/public",
      categories: [{ label: "Staging — Public", tags: ["REST", "JSON"] }],
    },
    {
      type: "file",
      input: "schema/staging-private.json",
      path: "staging/private",
      categories: [{ label: "Staging — Private", tags: ["REST", "JSON"] }],
    },
    {
      type: "file",
      input: "schema/prod-public.json",
      path: "public",
      categories: [{ label: "Public", tags: ["REST", "JSON"] }],
    },
    {
      type: "file",
      input: "schema/prod-private.json",
      path: "private",
      categories: [{ label: "Private", tags: ["REST", "JSON"] }],
    },
  ],
  navigation: [
    {
      type: "link",
      to: "/public",
      label: "Public API",
      icon: "book-open",
    },
    {
      type: "link",
      to: "/private",
      label: "Private API",
      icon: "lock",
    },
    {
      type: "link",
      icon: "square-library",
      to: "/catalog",
      label: "API Catalog",
    },
  ],
  navigationRules: [
    {
      type: "move",
      match: "schemas",
      position: "before",
      to: "1",
    },
  ],
  theme: {
    customCss: {
      '.bg-background.border-t.p-2.mx-5:has(a[href*="zudoku.dev"])': {
        display: "none !important",
      },
    },
  },
}

export default config
